import script from "./FullAcsEvents.vue?vue&type=script&setup=true&lang=ts"
export * from "./FullAcsEvents.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__